import { jsx } from "panel";
import { MarkdownEl } from "../markdown";
import { SvgIconEl } from "../svg-icon";
export function template() {
  const icon = this.attr(`icon`);
  const textBefore = this.attr(`text-before-icon`);
  return /* @__PURE__ */ jsx("span", null, /* @__PURE__ */ jsx(
    "div",
    {
      attrs: {
        elref: `textHighlight`
      },
      sel: ".mp-text-highlight",
      class: {
        [this.attr(`theme`)]: true,
        [`size-${this.attr(`size`)}`]: true,
        [`length-${this.attr(`length`)}`]: true,
        [`no-wrap`]: this.attr(`no-wrap`)
      }
    },
    icon && !textBefore && /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon } }),
    this.attr(`text`) && /* @__PURE__ */ jsx("div", { sel: ".text" }, this.attr(`text`)),
    this.attr(`markdown`) && /* @__PURE__ */ jsx("div", { sel: ".markdown.text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.attr(`markdown`) } })),
    icon && textBefore && /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon }, class: { "text-before-icon": true } })
  ), /* @__PURE__ */ jsx("slot", null));
}
